<template>
  <div class="total-items">
    <SfProperty
      v-for="total in totalsList"
      :key="total.name"
      :name="total.name"
      class="sf-property--full-width"
      :class="total.class"
    >
      <template #value>
        <SfPrice :regular="total.regular" />
      </template>
    </SfProperty>
  </div>
</template>
<script>
import {
  SfProperty,
  SfPrice,
} from '@storefront-ui/vue';
import { config } from '@/modules/core';

export default {
  name: 'Totals',
  props: {
    totals: {
      type: Object,
      required: true,
    },
  },
  mixins: [config],
  components: {
    SfProperty,
    SfPrice,
  },
  computed: {
    totalsList() {
      return [
        ...(() => (this.totals.OrderSubtotal ? [{
          name: this.$t('Sub Total'),
          regular: this.currencyFormatter().format(this.totals.OrderSubtotal),
        }] : []))(),
        ...(() => (this.totals.OrderSubTotalDiscount ? [{
          name: this.$t('Sub Total Discount'),
          regular: this.currencyFormatter().format(this.totals.OrderSubTotalDiscount),
        }] : []))(),
        ...(() => (this.totals.OrderShipping ? [{
          name: this.$t('Shipping'),
          regular: this.currencyFormatter().format(this.totals.OrderShipping),
        }] : []))(),
        ...(() => (this.totals.PaymentMethodAdditionalFee ? [{
          name: this.$t('Payment Method Fee'),
          regular: this.currencyFormatter().format(this.totals.PaymentMethodAdditionalFee),
        }] : []))(),
        ...(() => (this.totals.DisplayTax ? [{
          name: this.$t('Tax'),
          regular: this.currencyFormatter().format(this.totals.Tax),
        }] : []))(),
        ...(() => (this.totals.DisplayTaxRates ? this.totals.TaxRates.map((rate) => ({
          name: this.$t('Tax Rate'),
          regular: `${rate.Rate}% ${this.currencyFormatter().format(rate.Value)}`,
        })) : []))(),
        ...(() => (this.totals.OrderTotalDiscount ? [{
          name: this.$t('Order Total Discount'),
          regular: this.currencyFormatter().format(this.totals.OrderTotalDiscount),
        }] : []))(),
        {
          name: this.$t('Order Total'),
          regular: this.totals.OrderTotal
            ? this.currencyFormatter().format(this.totals.OrderTotal)
            : this.currencyFormatter().format(this.totals.OrderSubtotal),
          class: 'sf-property--large',
        },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

.total-items .sf-property {
  margin-bottom: 5px;
}
</style>
